import { render, staticRenderFns } from "./widgetFwAppRisk.vue?vue&type=template&id=483af7f8&scoped=true&"
import script from "./widgetFwAppRisk.vue?vue&type=script&lang=js&"
export * from "./widgetFwAppRisk.vue?vue&type=script&lang=js&"
import style0 from "./widgetFwAppRisk.vue?vue&type=style&index=0&id=483af7f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483af7f8",
  null
  
)

export default component.exports